import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";

import SidebarToolInfoModal from "../../components/SidebarToolInfoModal";
import {
  PLATFORM_ACCESS_HELP_TITLE,
  PlatformAccessHelpContent,
} from "./platformAccessHelpContent";
import "./PlatformAccessCountdown.css";

function formatDatePt(isoDate) {
  if (!isoDate) return "";
  const [year, month, day] = isoDate.split("-");
  if (!year || !month || !day) return isoDate;
  return `${day}/${month}/${year}`;
}

function buildTooltip(planAccess, t) {
  const paidUntil = formatDatePt(planAccess.paid_until);
  const accessEndsAt = formatDatePt(planAccess.access_ends_at);
  const renewalDate = formatDatePt(planAccess.renewal_date);
  const extraDays = planAccess.courtesy_days;

  if (planAccess.expired) {
    return t(
      "Acesso expirado em {{date}}. Renove a partir de {{renewal}} para manter o ciclo do plano.",
      { date: accessEndsAt, renewal: renewalDate }
    );
  }

  if (planAccess.in_courtesy_period) {
    return t(
      "Período pago encerrou em {{paidUntil}}. Acesso estendido por mais {{count}} dia(s) (+{{extra}}). Renove a partir de {{renewal}} — a data de cobrança não se desloca.",
      {
        paidUntil,
        count: planAccess.courtesy_days_remaining,
        extra: extraDays,
        renewal: renewalDate,
      }
    );
  }

  return t(
    "Plano pago até {{paidUntil}}. Acesso total até {{accessEndsAt}} (+{{extra}} dias extras). Próxima renovação: {{renewal}}.",
    {
      paidUntil,
      accessEndsAt,
      extra: extraDays,
      renewal: renewalDate,
    }
  );
}

function PlatformAccessCountdown({ planAccess, t }) {
  const [showHelp, setShowHelp] = useState(false);

  if (!planAccess) {
    return null;
  }

  const tooltip = buildTooltip(planAccess, t);
  let statusClass = "platform-access-countdown--active";
  let mainLabel;

  if (planAccess.expired) {
    statusClass = "platform-access-countdown--expired";
    mainLabel = t("Acesso expirado");
  } else if (planAccess.in_courtesy_period) {
    statusClass = "platform-access-countdown--extended";
    mainLabel = t("{{count}} dia(s) de acesso", {
      count: Math.max(planAccess.days_remaining, 0),
    });
  } else {
    mainLabel = t("{{count}} dia(s) de acesso", {
      count: Math.max(planAccess.days_remaining, 0),
    });
  }

  return (
    <>
      <li className="nav-item platform-access-countdown-wrap">
        <span
          className={`platform-access-countdown ${statusClass}`}
          title={tooltip}
          aria-label={tooltip}
        >
          <span className="platform-access-countdown__days">{mainLabel}</span>
          {!planAccess.expired ? (
            <span className="platform-access-countdown__extra">
              +{planAccess.courtesy_days}
            </span>
          ) : null}
        </span>
        <button
          type="button"
          className="platform-access-countdown__info-btn"
          title={t("Como funciona o acesso à plataforma?")}
          aria-label={t("Como funciona o acesso à plataforma?")}
          onClick={() => setShowHelp(true)}
        >
          <FaInfoCircle />
        </button>
      </li>
      {showHelp ? (
        <SidebarToolInfoModal
          title={t(PLATFORM_ACCESS_HELP_TITLE)}
          onClose={() => setShowHelp(false)}
        >
          <PlatformAccessHelpContent planAccess={planAccess} />
        </SidebarToolInfoModal>
      ) : null}
    </>
  );
}

export default withTranslation()(PlatformAccessCountdown);
